import { useCrud } from '@/hooks/useCrud'
import service from './offerCostBudget.service'
import { API_RESOURCE } from '@/constants/api.constant'
import { useQuery } from '@tanstack/react-query'
import useAction from '@/hooks/useAction'

const useOfferCostBudget = () => {
  const baseCrud = useCrud(API_RESOURCE.OFFER_COST_BUDGET)

  const useFetchVendorRFQs = (parameter) => baseCrud.useFetchAll(parameter, 'vendorRFQs')

  const useGetRFQDetail = ({ costBudgetId = '', ...options }) => {
    // Define when the query should be enabled
    const enabled = !!costBudgetId && costBudgetId !== ''

    return useQuery({
      queryKey: [...service.queryKey.detail(costBudgetId)],
      queryFn: () => service.getVendorCostBudgetDetail({ costBudgetId }),

      // Add the computed 'enabled' flag
      enabled: enabled,

      // Spread any custom options passed by the calling component (like staleTime, etc.)
      ...options,
    })
  }
  const useVendorUploadQuotation = useAction({
    mutationFn: service.vendorUploadQuotation,
    queryKey: service.queryKey,
  })
  const useVendorDeclineQuotation = useAction({
    mutationFn: service.vendorDeclineQuotation,
    queryKey: service.queryKey,
  })

  const useVendorUploadFrameAgreement = useAction({
    mutationFn: service.vendorUploadFrameAgreement,
    queryKey: service.queryKey,
  })
  return {
    useFetchVendorRFQs,
    useGetRFQDetail,
    useVendorUploadQuotation,
    useVendorDeclineQuotation,
    useVendorUploadFrameAgreement,
  }
}

export default useOfferCostBudget
